<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-03">The Cathedral Church of St. John the Divine stands in its beauty on Morningside Heights. The Stone Yard, started by Dean James Parks Morton, exists; and the dean and this exciting and unusual project are mentioned, as are Bishops Donegan and Moore, with affection and respect. But this is a work of fiction, and none of the imaginary characters bears any relation to any actual people, dead, living, or to be born.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?0eb5a4e3